import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { useThrottle } from '@wix/da-hooks/pkg/useThrottle';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import Plus from '@wix/da-ds/pkg/Icons/Plus';
import Check from '@wix/da-ds/pkg/Icons/Check';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { useRestrictToLoggedInAndVerified } from '../utils/hooks/useRestrictToLoggedInAndVerified';
import { ResourceType } from '../types/resource';
import s from './JoinGroupButton.scss';
const JoinGroupButton = ({ group , requestJoin , className , showAdminButton , type ='text'  })=>{
    var _group_extendedGroup, _group_extendedGroup1;
    const { t  } = useTranslation();
    const isMobile = useContext(MobileContext);
    // throttle those button presses so there's time for any notifications to disappear/backend requests to complete
    const requestJoinThrottled = useThrottle(()=>requestJoin(group), [
        requestJoin,
        group
    ], 6000);
    const { isLoggedIn , isVerificationNeeded , restrictToLoggedInAndVerified  } = useRestrictToLoggedInAndVerified();
    const loggedInAndVerified = isLoggedIn && !isVerificationNeeded;
    const biData = loggedInAndVerified ? {
        evid: BiEventType.JOIN_GROUP,
        groupid: group.useridUuid,
        sectionname: 'button'
    } : undefined;
    const onClick = restrictToLoggedInAndVerified(ReferralType.JOIN_GROUP, 'joingroup', requestJoinThrottled);
    if (((_group_extendedGroup = group.extendedGroup) === null || _group_extendedGroup === void 0 ? void 0 : _group_extendedGroup.isAdmin) && showAdminButton) {
        return /*#__PURE__*/ React.createElement(GhostButton, {
            size: "medium",
            variant: "approval-green",
            className: className,
            href: Url.groupNotificationsLink(group.userId),
            biData: {
                evid: BiEventType.VIEW_GROUP_NOTIFICATION,
                typeid: ResourceType.GROUP,
                itemid: group.userId,
                groupid: group.useridUuid,
                sectionname: 'button'
            }
        }, t('joinGroupButton.admin'));
    }
    if ((_group_extendedGroup1 = group.extendedGroup) === null || _group_extendedGroup1 === void 0 ? void 0 : _group_extendedGroup1.isIngroup) {
        return /*#__PURE__*/ React.createElement(TextButton, {
            size: "small",
            variant: "main",
            className: className,
            icon: Check,
            iconClassName: s['check-icon'],
            disabled: true,
            noHorizontalPaddings: false
        }, t('joinGroupButton.member'));
    }
    if (isMobile) {
        return /*#__PURE__*/ React.createElement(SolidButton, {
            variant: "approval-green",
            size: "small",
            className: className,
            onClick: onClick,
            biData: biData
        }, t('joinGroupButton.join'));
    }
    return type === 'text' ? /*#__PURE__*/ React.createElement(TextButton, {
        size: "small",
        variant: "approval-green",
        className: classnames(s['join-text-btn'], className),
        onClick: requestJoinThrottled,
        icon: Plus,
        iconClassName: s['plus-icon'],
        biData: {
            evid: BiEventType.JOIN_GROUP,
            groupid: group.useridUuid
        },
        noHorizontalPaddings: false
    }, t('joinGroupButton.join')) : /*#__PURE__*/ React.createElement(SolidButton, {
        size: "medium",
        variant: "approval-green",
        className: className,
        onClick: requestJoinThrottled,
        biData: biData
    }, t('joinGroupButton.join'));
};
JoinGroupButton.displayName = 'JoinGroupButton';
export default JoinGroupButton;
